import {Component, OnInit} from '@angular/core';
import {Question} from "../model/question";
import {RecommendationShort} from "../model/recommendation";
import {
  BOOL_OPERATORS,
  BY_ANSWER_EXPLANATION_TYPE,
  ITERABLE_OPERATORS,
  NO_LABEL,
  RECOMMENDATION_SUPPORTED,
  RECOMMENDATION_TYPES,
  TEXT_EXPLANATION_TYPE,
  YES_LABEL,
  YES_NO_ANSWER_TYPE_NAME
} from "../constants";
import {PlaylistInfo} from "../model/playlist-info";
import {RecommendationClauseShort} from "../model/recommendation-clause";
import {ExplanationQuestionShort, ExplanationShort} from "../model/explanation";

@Component({
  selector: 'app-recommendation-edit-wizard',
  templateUrl: './recommendation-edit-wizard.component.html',
  styleUrls: ['./recommendation-edit-wizard.component.css']
})
export class RecommendationEditWizardComponent implements OnInit {

  maxRecommendationDescriptionLength = 256;

  recommendationId: string;
  recommendationType: string;
  recommendationDescription: string;
  recommendationEditWizardStep: number;
  availableRecommendationAnswers: string[];
  questions: Question[];
  selectedQuestions: Question[] = [];
  questionDataProvider: { checked: boolean, question: Question }[] = [];
  selectedAnswer: string;
  explanationSummary: string;
  explanationsByAnswers: { question: Question, text: string, playlist: PlaylistInfo }[];
  playlists: PlaylistInfo[];

  onCancelCallback: () => void;
  onSubmitCallback: (id: string, r: RecommendationShort) => void;


  availableRecommendationTypes: string[] = RECOMMENDATION_TYPES;
  availableQuestionOperators: string[] = ITERABLE_OPERATORS;

  recommendationDescriptionFieldError: string = null;
  editRecommendationQuestionOperator: string;
  private quesitonsFieldError: string = null;

  constructor() {
  }

  ngOnInit() {
    this.recommendationEditWizardStep = 1;
    this.availableRecommendationAnswers = [YES_LABEL, NO_LABEL];
    this.questionDataProvider = this.questions
      .filter(q => RECOMMENDATION_SUPPORTED.some(at => at.type == q.answer.type))
      .map(q => {
        return {
          question: q,
          checked: this.selectedQuestions.some(clauseQuestion => clauseQuestion.id == q.id)
        };
      });
  }

  movePrev() {
    switch (this.recommendationEditWizardStep) {
      case 1:
        this.closeWizard();
        return;
    }
    this.recommendationEditWizardStep--;
  }

  moveNext() {
    switch (this.recommendationEditWizardStep) {
      case 1:
        if (!this.validateRecommendationDescription()) {
          return;
        }
        break;
      case 4:
        this.selectedQuestions = this.questionDataProvider
          .filter(o => o.checked)
          .map(o => o.question);

        if (!this.validateRecommendationQuestions()) {
          return;
        }
        break;
      case 5:
        this.explanationsByAnswers = this.selectedQuestions.map(q => {
          let existedExplanation = this.explanationsByAnswers.find(e => e.question.id == q.id);
          return existedExplanation ? existedExplanation : {question: q, text: null, playlist: null};
        });
        break;
      case 7:
        this.submitRecommendation();
        return;
    }
    this.recommendationEditWizardStep++;
  }

  getQuestionOperatorLabel(questionOperator: string, answer: string) {
    switch (questionOperator) {
      case "each":
        return `User has to answer ${answer} to the all chosen questions`;
      case "any":
        return `User has to answer ${answer} at least to one of the chosen questions`;
      default:
        return questionOperator;
    }
  }

  closeWizard() {
    this.onCancelCallback();
  }

  questionOperatorDescription(questionOperator: string): string {
    switch (questionOperator) {
      case 'each':
        return "to all the questions";
      case 'any':
        return "at least to one of the quesitons";
      default:
        return questionOperator;
    }
  }

  comparePlaylists(p1: PlaylistInfo, p2: PlaylistInfo): boolean {
    return p1 && p2 && p1.id == p2.id;
  }

  private submitRecommendation() {
    let type: string = this.recommendationType;
    let description: string = this.recommendationDescription;
    let id = this.recommendationId;


    let clauseShort: RecommendationClauseShort = new RecommendationClauseShort(
      YES_NO_ANSWER_TYPE_NAME,
      BOOL_OPERATORS[0],
      this.selectedAnswer,
      this.editRecommendationQuestionOperator,
      this.selectedQuestions.map(q => q.id)
    );
    let explanationsShort: ExplanationShort[] = this.explanationsByAnswers.map(e => {
      return new ExplanationShort(
        BY_ANSWER_EXPLANATION_TYPE,
        new ExplanationQuestionShort(e.question.id, this.selectedAnswer, e.text, e.playlist != null ? e.playlist.id : null))
    });
    explanationsShort.unshift(new ExplanationShort(TEXT_EXPLANATION_TYPE, this.explanationSummary));
    let recommendationShort: RecommendationShort = new RecommendationShort(type, [clauseShort], explanationsShort, description);

    this.onSubmitCallback(id, recommendationShort);
  }

  private validateRecommendationDescription() {
    if (this.recommendationDescription == null || this.recommendationDescription.length == 0) {
      this.recommendationDescriptionFieldError = "This field is required.";
      return false;
    } else if (this.recommendationDescription.length > this.maxRecommendationDescriptionLength) {
      this.recommendationDescriptionFieldError = "You have exceeded the input length.";
      return false;
    }
    this.recommendationDescriptionFieldError = null;
    return true;
  }

  private validateRecommendationQuestions() {
    if (this.selectedQuestions.length == 0) {
      this.quesitonsFieldError = "Select at least one question";
      return false;
    }
    this.quesitonsFieldError = null;
    return true;
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/recommendation-edit-wizard/recommendation-edit-wizard.component.ts